<ng-container *transloco="let tr; prefix:'compositeProducts'; scope: 'composite-products'">
  <nz-affix [nzOffsetTop]="0">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>{{'compositeProducts.title' | transloco}}</nz-page-header-title>
      <nz-page-header-subtitle>{{'compositeProducts.subTitle' | transloco}}</nz-page-header-subtitle>
      <nz-page-header-extra>
        <a routerLink="new" nz-button nzType="primary">
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'compositeProducts.button.addNew' | transloco}}
        </a>
      </nz-page-header-extra>
    </nz-page-header>
  </nz-affix>
  <!--<nz-skeleton *ngIf="isLoading" [nzActive]="true"></nz-skeleton>-->
  <nz-table [nzLoading]="isTableLoading" #compositeProductsTable
            [nzTotal]="total"
            [nzPageSize]="limit"
            [nzPageIndex]="page"
            [nzData]="list"
            (nzQueryParams)="onQueryParamsChange($event)"
            [nzFrontPagination]="false">
    <thead>
    <tr>
      <th nzColumnKey="title" [nzSortOrder]="columnSortOrderMap.get('title') || null" [nzSortFn]="true" [nzSortPriority]="1">{{'compositeProducts.column.title' | transloco}}</th>
      <th nzCustomFilter>
        {{'compositeProducts.column.country' | transloco}}
        <nz-filter-trigger [(nzVisible)]="countryFilter.isVisible" [nzActive]="countryFilter.isActive" [nzDropdownMenu]="countryFilterMenu">
          <i nz-icon nzTheme="fill" nzType="filter"></i>
        </nz-filter-trigger>
      </th>
      <th nzColumnKey="type" [nzSortOrder]="columnSortOrderMap.get('type') || null" [nzSortFn]="true" [nzSortPriority]="2">{{'compositeProducts.column.type' | transloco}}</th>
      <th nzColumnKey="price" [nzSortOrder]="columnSortOrderMap.get('price') || null" [nzSortFn]="true" [nzSortPriority]="3">{{'compositeProducts.column.price' | transloco}}</th>
      <th nzCustomFilter>
        {{'compositeProducts.column.tags' | transloco}}
        <nz-filter-trigger [(nzVisible)]="tagsFilter.isVisible" [nzActive]="tagsFilter.isActive" [nzDropdownMenu]="tagsFilterMenu">
          <i nz-icon nzTheme="fill" nzType="filter"></i>
        </nz-filter-trigger>
      </th>
      <th nzColumnKey="products">{{'compositeProducts.column.products' | transloco}}</th>
      <th nzWidth="100px">#</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of list">
      <td>{{ data.title | uiLabel }}</td>
      <td>{{ data.countryTitle }}</td>
      <td>{{ ('enum.CompositeProductType.' + data.type) | transloco }}</td>
      <td>{{ data.price }}</td>
      <td>{{ data.tags }}</td>
      <td>{{ data.subProductTitles }}</td>
      <td>
        <nz-button-group>
          <button [routerLink]="data.id + '/edit'" nz-button nzType="primary">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </button>
          <button nz-button nzType="default" nzDanger nz-popconfirm
                  [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                  [nzCancelText]="'no1' | transloco"
                  (nzOnConfirm)="remove(data)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </button>
        </nz-button-group>
      </td>
    </tr>
    </tbody>
  </nz-table>

  <nz-dropdown-menu #countryFilterMenu>
    <div class="cp__filter ant-table-filter-dropdown">
      <nz-checkbox-group [(ngModel)]="countryFilter.options"></nz-checkbox-group>

      <div class="ant-table-filter-dropdown-btns">
        <button (click)="resetFilter(countryFilter)" nz-button nzType="link" nzSize="small" tabindex="-1">Сбросить</button>

        <nz-radio-group nzName="countryFilterOperator" [(ngModel)]="countryFilter.operator" nzSize="small">
          <label nz-radio-button nzValue="or">или</label>
          <label nz-radio-button nzValue="and">и</label>
        </nz-radio-group>

        <button (click)="applyFilter(countryFilter)" nz-button nzType="primary" nzSize="small">OK</button>
      </div>
    </div>
  </nz-dropdown-menu>

  <nz-dropdown-menu #tagsFilterMenu>
    <div class="cp__filter ant-table-filter-dropdown">
      <nz-checkbox-group [(ngModel)]="tagsFilter.options"></nz-checkbox-group>

      <div class="ant-table-filter-dropdown-btns">
        <button (click)="resetFilter(tagsFilter)" nz-button nzType="link" nzSize="small" tabindex="-1">Сбросить</button>

        <nz-radio-group nzName="tagsFilterOperator" [(ngModel)]="tagsFilter.operator" nzSize="small">
          <label nz-radio-button nzValue="or">или</label>
          <label nz-radio-button nzValue="and">и</label>
        </nz-radio-group>

        <button (click)="applyFilter(tagsFilter)" nz-button nzType="primary" nzSize="small">OK</button>
      </div>
    </div>
  </nz-dropdown-menu>

</ng-container>
